<template>
  <span
    class="teaser-indicator"
    :class="{ 'teaser-indicator__menu': displayInMenu }"
  />
</template>

<script>
export default {
  name: "TeaserIndicator",
  props: {
    displayInMenu: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.teaser-indicator {
  background-color: $ds-yellow-5;
  border-radius: 50%;
  height: 14px;
  position: absolute;
  right: -24px;
  top: calc(50% - 9px);
  width: 14px;
  opacity: 1 !important;

  &__menu {
    right: 2px;
    top: 2px;
  }
}

.teaser {
  &:hover {
    .teaser-indicator {
      display: none;
    }
  }
}
</style>
